<template>
    <section class="app-main">
        
        <el-card class="content">
            <el-table :data="tableData" empty-text="暂无优惠券"  height="650" style="width: 100%">
                <el-table-column type="selection" width="60" align="center"> </el-table-column>
                <el-table-column prop="title" label="中文图" align="center" >
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.pic" :src="scope.row.pic.url" :width="351" :height="114" />
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="英文图" align="center" >
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.pic_en" :src="scope.row.pic_en.url" :width="351" :height="114" />
                    </template>
                </el-table-column>
                <el-table-column prop="discount"  align="center" label="类型">
                    <template slot-scope="scope">
                        <el-link type="primary" v-if="scope.row.discount == 1">商品代金券</el-link>
                        <el-link type="success" v-if="scope.row.discount == 2">商品满减券</el-link>
                        <el-link type="warning" v-if="scope.row.discount == 3">商品折扣券</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="discount"  align="center" label="优惠">
                    <template slot-scope="scope">
                        <el-link type="danger" v-if="scope.row.discount == 1">C${{scope.row.coupon_money}}</el-link>
                        <el-link type="danger" v-if="scope.row.discount == 2">满C${{scope.row.full_money}}</el-link>
                        <el-link type="danger" v-if="scope.row.discount == 2">减C${{scope.row.reduce}}</el-link>
                        <el-link type="danger" v-if="scope.row.discount == 3">{{scope.row.coupon_money}}%</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="range"  align="center" label="使用范围">
                    <template slot-scope="scope">
                        <el-link type="primary" v-if="scope.row.range == 1">全平台可用</el-link>
                        <el-link type="success" v-if="scope.row.range == 2">自营商品可用</el-link>
                        <el-link type="warning" v-if="scope.row.range == 3">预售商品可用</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="stock"  align="center" label="数量"></el-table-column>
                <el-table-column prop="user_get_num"  align="center" label="领取数量"></el-table-column>
                <el-table-column prop="use_number"  align="center" label="使用数量"></el-table-column>
                <el-table-column prop="date"  align="center" label="有效日期" width="185">
                    <template slot-scope="scope">
                        <el-link type="success" v-if="scope.row.fixed == 1">开始：{{scope.row.st_time}}</el-link>
                        <el-link type="warning" v-if="scope.row.fixed == 1">结束：{{scope.row.end_time}}</el-link>
                        <el-link type="success" v-if="scope.row.fixed == 2">领取后{{scope.row.fixed_time}}天内可用</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="flag"  align="center" label="状态">
                    <template slot-scope="scope">
                        <el-link type="primary" v-if="scope.row.flag == 0">未启用</el-link>
                        <el-link type="success" v-if="scope.row.flag == 1">已启用</el-link>
                        <el-link type="info"    v-if="scope.row.flag == 2">已禁用</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="code"  align="center" label="兑换码" >
                    <template slot-scope="scope">
                        <el-popover placement="top" trigger="hover">
                            <el-button type="success" plain size="small" @click="handleCopy(scope.row.code)" style="margin-left:35px">点击复制</el-button>
                            <el-button type="primary" plain size="small" @click="handleShow(scope.row)" style="margin-right:35px">修改</el-button>
                            <el-button slot="reference" size="small" type="text">{{scope.row.code}}</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="编辑" align="center">
                    <div slot-scope="scope" class="table-btns">
                        <el-button type="success" plain size="mini" @click="handleFlag(scope.row, 1)" style="margin:0;margin-top:5px">启用</el-button>
                        <el-button type="info"    plain size="mini" @click="handleFlag(scope.row, 2)" style="margin:0;margin-top:5px">禁用</el-button>
                        <!-- <el-button type="danger"  plain size="mini"  @click="handleDel(scope.row)" style="margin:0">删除</el-button> -->
                    </div>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>
        <el-dialog :visible.sync="codeShow" title="修改"  width="600px" align="center">
            <el-row class="m-bottom-4">
               <el-col :span="3" class="input-left">兑换码：</el-col>
               <el-col :span="20" class="input-left">
                   <el-input placeholder="请输入兑换码" v-model="code"></el-input>
               </el-col>
           </el-row>
           <el-row type="flex" class="line-item" justify="center">
                <el-col :span="6" style="text-align:center"><el-button  type="info" plain @click="codeShow = false" style="width:120px">取消</el-button></el-col>
                <el-col :span="6" style="text-align:center"><el-button  type="primary" plain @click="handleBtn" style="width:120px">确定</el-button></el-col>
            </el-row>
        </el-dialog>

    </section>
</template>



<script>
import { coupon_list, coupon_put, coupon_del } from '@/api/market.js'
import MImg   from './../../../components/Image'
export default {
    components: { MImg },
    data() {
        return {
            tableData:[],
            total:0,
            page:1,
            size: 0,
            codeShow: false,
            code: '',
            id: ''
        }
    },
    methods: {
        search(){
           
        },
        getData(){
            let params = {
                page:this.page,
                limit: 20,
            }
            coupon_list(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size = res.data.per_page
                }else{
                    this.tableData = [];
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                this.table_load = false
                console.log(err)
            })
        },
        reloadData(page){
            this.page = page;
            this.getData();
        },
        // 显示修改兑换码弹窗
        handleShow(row) {
            this.id = row.id
            this.code = row.code
            this.codeShow = true
        },
        handleBtn() {
            let params = {}
            if(this.code.length > 6) {
                this.$message({type:'warning',message:'输入的兑换码不能超过六位'})
                return false
            }
            if(this.code.trim() == '') {
                this.$message({type:'warning',message:'输入的兑换码不能未空'})
                return false
            } 
            params.code = this.code
            coupon_put(this.id,params).then(res => {
                if(res) {
                    this.$message({type:'success',message:res.msg})
                    this.getData()
                    this.codeShow = false
                }
            })
        },
        // 启用  禁用
        handleFlag(row, flag) {
            let params = {
                flag: flag
            }
            coupon_put(row.id, params).then(res => {
                if(res) {
                        this.$message({type:"success",message:res.msg})
                        row.flag = flag
                }
            })
        },
        

        // 删除优惠券
        handleDel(row) {
             this.$confirm(`此操作将删除当前优惠券，是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                coupon_del(row.id).then(res => {
                    this.$message({type:"success",message:res.msg})
                    this.getData();
                })
            })
        },

        // 复制兑换码
        handleCopy(code) {
            navigator.clipboard.writeText('MoobyYoho 送您优惠券啦！兑换码' + code + '，赶紧进入Mooby网站进入我的-优惠券进行兑换吧。');
            this.$message({type:"success",message: '复制成功！'})
        }

    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    .content {
        margin-top: 20px;
    }
    .input-left {
        height: 40px;
        line-height: 40px;
        text-align: left;
    } 
}
</style>
